var exports = {
  "Qs": "xcc377c0b--32c23e--content",
  "su": "xcc377c0b--32c23e--icon-wrapper",
  "R_": "xcc377c0b--32c23e--heading",
  "qr": "xcc377c0b--32c23e--footer",
};

module.exports = exports;
